"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdStatusToJSON = exports.AdStatusFromJSONTyped = exports.AdStatusFromJSON = exports.AdStatus = void 0;
/**
 * Status of the ad.
 * @export
 */
exports.AdStatus = {
    Active: 'ACTIVE',
    Approved: 'APPROVED',
    Archived: 'ARCHIVED',
    Pending: 'PENDING',
    PendingAdvertiserApproval: 'PENDING_ADVERTISER_APPROVAL',
    PendingApproval: 'PENDING_APPROVAL',
    Rejected: 'REJECTED',
    Unrecognized: 'UNRECOGNIZED'
};
function AdStatusFromJSON(json) {
    return AdStatusFromJSONTyped(json, false);
}
exports.AdStatusFromJSON = AdStatusFromJSON;
function AdStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.AdStatusFromJSONTyped = AdStatusFromJSONTyped;
function AdStatusToJSON(value) {
    return value;
}
exports.AdStatusToJSON = AdStatusToJSON;
